import AbstractModal from '../shared/modal';
import { formatDate } from '../../helpers/utils';

export default class DeliveryDateHistoryModal extends AbstractModal {

  constructor(private dates: { dateChanged: string, newDeliveryDate: string }[]) {
    super('.js-deliveryDateHistoryModal');
  }

  protected openCallback = () => {
    const contentContainer = $('.js-deliveryDateHistoryModalContent');
    this.dates.forEach((date) => {
      $(`<p>${formatDate(new Date(date.dateChanged))} → ${formatDate(new Date(date.newDeliveryDate))}</p>`).appendTo(contentContainer);
    });
  };

}
